<template>
	<v-card outlined>
		<v-card-text>
			<v-data-table
				dense
			    :headers="headers"
			 	:items="list"
			    class="elevation-5"			    
			    :hide-default-footer="height < 56 ?  true : false"
			   	:options.sync="options"
			   	:server-items-length="total"
			   	:footer-props="{
			   		showFirstLastPage: true,
			   		itemsPerPageOptions: [15, 30],
			   		showCurrentPage: true
			   	}"				   	
			    :height="height+'px'"
			    fixed-header
			    item-key="index"
			>
				<template v-slot:item.isPopup="{ item }">
					<v-btn
				        small
				        :color="item.isPopup=='1' ? 'primary' : 'secondary'"
				        v-text="item.isPopup=='1' ? 'ON' : 'OFF'"
				        class="pa-0"
				        @click.stop="update(item, 'popup')"
				        v-model="item.isPopup"
				        dense
				        hide-details
				        
				    >				       
				    </v-btn>
				</template>
				<template  v-slot:item.isSound="{ item }">
					
				    <v-btn
				        small
				        :color="item.isSound=='1' ? 'info' : 'secondary'"
				        v-text=" item.isSound=='1' ? 'ON' : 'OFF'"
				        class="pa-0"
				        @click.stop="update(item, 'sound')"
				        v-model="item.isSound"
				        dense
				        hide-details
				        
			    	>				 
					</v-btn>
				</template>
				<template  v-slot:item.actions="{ item }">
					<v-icon
				        small
				        color="primary"
				        class="mr-2"
				        @click="edit(item)"
				      >
				        mdi-pencil
				      </v-icon>
				      <v-icon
				        small
				        color="error"
				        @click="del(item)"
				      >
				        mdi-delete
				      </v-icon>
				</template>
				<template v-slot:item.timeout="{ item }">
					
					<v-icon
						small						
						color="primary"
						v-text="'mdi-timer'"
						@click="edit_timeout(item)"
					></v-icon>
					<span 
						v-text="item.timeout"
						class="col-md-2 mr-1"
					></span>
					<span
						class="secondary--text"
						v-text="'seg'"
					></span>
				</template>
			</v-data-table>
		</v-card-text>
		<notifications
			v-if="info_to_modal"
			:info="info_to_modal"
			@confirm_message="confirm_del($event)"
			@close_snack_dialog="info_to_modal=$event"
		></notifications>
		<v-dialog 
			v-model="dialog_timer"
			width="300"
		>
			<v-card outlined>
				<v-card-title
					v-text="$ml.get('timeout')"
					class="justify-center body-2 primary pa-1"
				></v-card-title>
				<v-card-text class="pb-0">
					<v-row >
						<v-col md="8">
							<v-text-field
								v-model.number="update_item.timeout"
								type="number"
								dense
								hide-details
								:label="$ml.get('seconds')"
							></v-text-field>
						</v-col >
						<v-col md="2" class="pt-1">
							<v-btn 
								x-small
								@click="update_item.timeout++"
							>
								<v-icon
									x-small
									color="primary"
									v-text="'mdi-sort-clock-descending'"
								></v-icon>
							</v-btn>
							<v-btn 
								x-small
								@click="update_item.timeout > 0 ? update_item.timeout-- : 0"
							>
								<v-icon
									x-small
									color="error"
									v-text="'mdi-sort-clock-ascending'"
								></v-icon>
							</v-btn>
						</v-col>
					</v-row>

				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						x-small
						v-text="$ml.get('save')"
						@click="update(update_item, 'timeout')"
					></v-btn>
					<v-btn
						color="error"
						x-small
						v-text="$ml.get('close')"
						@click="dialog_timer=false"
					></v-btn>

				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>
<script>
import notifications from '@/components/info/notifications.vue'
import axios from 'axios'

	export default{
		name: 'alert_sounds',
		components:{
			notifications
		}, // components
		props: ['inf_to_table','is_actions'],
		data: vm => ({
			inf: {},
			headers:[
				// { text: vm.$ml.get('id'), value: 'id', align: 'center' },
				{ text: vm.$ml.get('category'), value: 'name', align: '' },
				{ text: vm.$ml.get('pop_ups'), value: 'isPopup', align: '' },
				{ text: vm.$ml.get('sounds'), value: 'isSound', align: '' },
				{ text: vm.$ml.get('timeout'), value: 'timeout', align: '' }, 
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' }, 
			],
			list: [],
			height: 350,
			options: {itemsPerPage: 30},
			total: 1,
			del_item: 0,
			is_show: false,
			update_item: '',
			info_to_modal: null,		
			dialog_timer: false,
			timer: 0,
			name_change: '',
		}), // data
		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true, 
			}, // options

			is_actions: function (val){
				if(val){
					console.log(val, 'actions of settings')
					if (this.inf_to_table) {
						this.inf=this.inf_to_table;
						console.log(this.inf_to_table, 'info table');
					}
					if(val=='save'){
						this.save();
					}else if(val=="update"){
						this.update(this.update_item, 'settings');
					}
				}
			},
		}, // watch

		methods: {
			get_list(){
				const { page, itemsPerPage } = this.options;
				let pg=1, sw=0;
				if (itemsPerPage==15) {
					if (page % 2 == 0) {
						pg=(page/2);
						sw=2;
					}else{
						pg=parseInt(page/2)+1;
						sw=1;
					}
				}else{
					pg=page
				}
				
				const api = this.$URL + '/api/v1/category/?page='+ pg;
				axios.defaults.withCredentials=true;
				axios.get(api).then( res => {
					let item =res.data;
					let items=item.rows;
					this.total=parseInt(item.count);
					if (itemsPerPage<=15) {
						items=items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					}				
					this.list=items;
					// let list_new=[];
					
					/*for(let j of items){
						if (this.render_hostname(j)) {

							list_new.push(this.info_format(j));
						}
					}*/
					this.save_local();
				}).catch( er =>{
					console.log(er, 'error get list sz_contacts')
				})
			}, // get list
			save(){
				
				
				// 
					let info_to_up=this.inf;
					let info_update={
						name: info_to_up.name,
						isSound: info_to_up.isSound,
						isPopup: info_to_up.isPopup,
						timeout: info_to_up.timeout,
					}
					const api = this.$URL + '/api/v1/category';
					axios.defaults.withCredentials=true;
					axios.post(api, info_update).then( res => {
						this.info_to_modal={ 
							snack: true, 
							type: false,
							color: 'success',
							info: this.$ml.get('save'),
						}
						// this.show=false;
						this.$emit('is_show', false);
						this.$emit('is_actions', false);
						this.$emit('edit_item', {});
						this.list.push(info_update);
						this.save_local();
						// this.get_list();	
					}).catch( er => {
						console.log(er, 'error update sz contacts');
					})
			
			},
			update(val, from){
				let vl=null;
				let info_to_up=null;
				if (from!=='settings') {
					vl=val.id;
					info_to_up=val;
				}else{
					vl=val.id;
					info_to_up=this.inf;
				}
				if ((info_to_up.isSound || !info_to_up.isSound) && from=='sound') {
					info_to_up.isSound=!info_to_up.isSound
				}
				if ((info_to_up.isPopup || !info_to_up.isPopup) && from=='popup') {
					info_to_up.isPopup=!info_to_up.isPopup;
				}
				let info_update={
					name: info_to_up.name,
					isSound: info_to_up.isSound,
					isPopup: info_to_up.isPopup,
					timeout: info_to_up.timeout,
				}
				console.log(val, info_to_up, info_update, 'info to update')
				const api = this.$URL + '/api/v1/category/'+vl;

				axios.defaults.withCredentials=true;
				axios.put(api, info_update).then( res => {
					this.info_to_modal={ 
						snack: true, 
						type: false,
						color: 'success',
						info: this.$ml.get('updated'),
					}
					let items=this.list;
					// let this.list=items.indexOf(val);
					// this.list.splice(items.indexOf(val), 1, info_update);
					this.list[items.indexOf(val)].timeout=info_to_up.timeout;
					if(from=='sound'){
						this.list[items.indexOf(val)].isSound=val.isSound;
						
					}
					if(from=='popup'){
						this.list[items.indexOf(val)].isPopup=val.isPopup;
						
					}
					if (from=='timeout') {
						this.dialog_timer=false;
					}
					if(from=='settings'){
						
						this.list[items.indexOf(val)].name=info_to_up.name;				
						this.list[items.indexOf(val)].isPopup=info_to_up.isPopup==(1 || '1') ? true : false;
						this.list[items.indexOf(val)].isSound=info_to_up.isSound==(1 || '1') ? true : false;						
						this.$emit('is_show', false);
						this.$emit('edit_item', {});
						this.$emit('is_actions', false);					
					}
					// this.get_list();
					this.inf={};
					this.update_item='';
					this.save_local(this.name_change, info_to_up);
					// this.show=false;
					// let items=this.list;
				}).catch( er => {
					console.log(er, 'error update alert sound');
						if(from=='settings'){
							this.$emit('is_actions', false);
						}
				})
			}, // update
			edit(item){
				// this.show=true;
				this.update_item=item;
				this.name_change=item.name;
				/*this.inf.name=item.name;
				this.inf.isSound=item.isSound;
				this.inf.isPopup=item.isPopup;*/
				let info_to_update={
					name: item.name,
					isSound: item.isSound==1 ? true : false,
					isPopup: item.isPopup==1 ? true : false,
					timeout: item.timeout
				}
				this.$emit('edit_item', info_to_update);
				this.$emit('is_show', true);
				this.$emit('is_to_update', true);

			}, // edit

			edit_timeout(item){
				this.dialog_timer=true;
				this.update_item=item;
			}, // edit timeout

			del(item){
				this.del_item=item;

				this.info_to_modal={ 
					dialog: true, 
					type: true,
				}
			}, // del

			confirm_del(val){
				if(val){
					this.info_to_modal=null;
					const api = this.$URL + '/api/v1/category/'+this.del_item.id;
					axios.defaults.withCredentials=true;
					axios.delete(api).then( res => {
						this.info_to_modal={ 
							snack: true, 
							type: false,
							color: 'success',
							info: this.$ml.get('deleted'),
						}
						
						console.log(this.del_item, 'item to del', val)
						// this.get_list();
						/*let list_temp=[];
						if (localStorage.getItem('alert_sounds_setting')) {
							list_temp=JSON.parse(localStorage.getItem('alert_sounds_setting'))
							let idx=0;
							console.log(list_temp, 'list to del')
							for (let i = 0; i < list_temp.length; i++) {
								console.log(list_temp[i].name, 'name to del' , this.del_item.name)
								if(list_temp[i].name == this.del_item.name){
									idx=i;
								}
							}
							list_temp.splice(idx, 1);
								console.log(list_temp, 'list end del')
							let temp=JSON.stringify(list_temp);
							localStorage.setItem('alert_sounds_setting', temp);
						}		*/
						this.save_local();
						this.list.splice(this.list.indexOf(this.del_item), 1)
					}).catch ( er => {
						console.log(er, 'error delete item category')
					})
				}
			}, // confirm del

			save_local(name='',  from){
				let list_t=[], list_temp=this.list, up_name=false;
				/*if (name!=='') {
					up_name=true;
				}
				if (localStorage.getItem('alert_sounds_setting')) {
					list_t=JSON.parse(localStorage.getItem('alert_sounds_setting'))
					console.log(list_t, 'init save local')
					if (list_t.length>0) {

						for (var i = 0; i < list_t.length; i++) {
							let sw=true, idx=0, idxj=0;
							if (up_name) {
								console.log('name to change', name)
								if (name==list_t[i].name) {									
									list_t[i]=from;
									i=list_t.length;								
								}
							}else{

								for (var j = 0; j < list_temp.length ; j++) {							
									console.log(list_t[i].name, 'name list t', list_temp[j].name)	
									// for update
									if(list_t[i].name == list_temp[j].name && list_t.length == list_temp.length){								
										sw=false;
										idx=i;
										idxj=j;
									}
									
								}
								if (sw) {						
									console.log(sw, 'save new to local')
									list_t.push(list_temp[list_temp.length]);
								}else if(!sw){
									console.log(sw, 'update to local')
									list_t[idx]=list_temp[idxj];
								}
							}
							
							
						} // for
					}
				}
				if(list_t.length==0){*/
					list_t=list_temp;
				// }
				console.log(list_t, 'save end ')
				let inf_to_local=JSON.stringify(list_t);
				localStorage.setItem('alert_sounds_setting', inf_to_local);
			}, // save local

			close_inf(){
				
			}, // close_inf
		}, // methods
		
		mounted(){
			// Cargar configuración de sonidos de alerta desde localStorage
			if (localStorage.getItem('alert_sounds_setting')) {
				this.list = JSON.parse(localStorage.getItem('alert_sounds_setting'));
			}
		}, // mounted
		
	}; 
</script>